import React from "react";
import { Breadcrumb } from "antd";
import { useState } from "react";
import LookingForChangeTabs from "./lookingForChangeTabs";

const LookingForChange = () => {
  const [breadcrumb,setBreadcrumb] = useState("Banner")
  return (
    <div className="mb-6">
      <h1 className="text-xl sm:text-3xl font-semibold sm:mb-1">Looking For A Change?</h1>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Looking For A Change?" }, { title: breadcrumb }]}
        />
      </div>
      <LookingForChangeTabs setBreadcrumb={setBreadcrumb}/>
    </div>
  );
};

export default LookingForChange;
